'use client';

import React from 'react';
import { buildTrackingId } from '@/utils/tracking-helper';
import { RichTextRenderer } from '../../tileRenderers/RichTextRenderer';
import Button from '../../shared/Button';
import { NewsletterSignupTile } from './types/NewsletterSignupTile';

export default function NewsletterSignup({
  tile,
  trackingPrefix,
}: Readonly<{
  tile: NewsletterSignupTile;
  trackingPrefix?: string;
}>) {
  const { title } = tile;
  const subtitle = tile.subtitle?.text;
  const emailPlaceholder = tile['email-placeholder']?.text;
  const privacyPolicy = tile['privacy-policy'];
  const buttonText = tile['button-text']?.text;

  const submitButtonTrackingId = buildTrackingId(trackingPrefix, buttonText);

  return (
    <div className=" my-8 bg-neutral-5 px-4 pb-12 pt-14 sm:my-14 sm:px-8 sm:pb-14 sm:pt-16 lg:my-16">
      <div className=" space-y-6 text-center">
        <RichTextRenderer blocks={title} className="text-3xl md:text-4xl" />
        {subtitle && <p className=" px-8 text-xl md:text-2xl">{subtitle}</p>}
      </div>
      {/* TODO once specified: Newsletter Logic */}
      <form className="mx-auto mt-14 flex max-w-sm flex-col items-center space-y-4">
        <input
          type="email"
          name="email"
          id="email"
          placeholder={emailPlaceholder || ''}
          className="w-full rounded-full border-2 border-neutral-20 bg-white px-5 py-4 outline-none focus:border-primary-60"
        />
        {/* Checkbox privacy policy */}
        <div className="flex gap-2">
          <input type="checkbox" name="privacy-policy" id="privacy-policy" />
          {/* eslint-disable-next-line */}
          <label htmlFor="privacy-policy" className="text-sm text-neutral-50">
            <RichTextRenderer blocks={privacyPolicy} />
          </label>
        </div>
        {/* eslint-disable-next-line no-console */}
        <Button
          className="w-full"
          type="submit"
          onClick={() => console.log('Submited data')}
          data-tile-element-id={submitButtonTrackingId}
        >
          {buttonText}
        </Button>
      </form>
    </div>
  );
}
